import { toast } from "react-toastify";

const DEFAULT_AUTO_CLOSE = 10;

export function showPromiseToast(promise, messages, autoClose = DEFAULT_AUTO_CLOSE) {
	return toast.promise(
		promise,
		{
			pending: messages.pending,
			success: messages.success,
			error: messages.error,
		},
		{
			position: "bottom-right",
			autoClose: autoClose * 1000,
			theme: "colored",
		}
	);
}

export function showErrorToast(message, autoClose = DEFAULT_AUTO_CLOSE) {
	toast.error(message, {
		position: "bottom-right",
		autoClose: autoClose * 1000,
		theme: "colored",
	});
}

export function showSuccessToast(message, autoClose = DEFAULT_AUTO_CLOSE) {
	toast.success(message, {
		position: "bottom-right",
		autoClose: autoClose * 1000,
		theme: "colored",
	});
}

export function showWarningToast(message, autoClose = DEFAULT_AUTO_CLOSE) {
	toast.warn(message, {
		position: "bottom-right",
		autoClose: autoClose * 1000,
		theme: "colored",
	});
}

export function showInfoToast(message, autoClose = DEFAULT_AUTO_CLOSE) {
	toast.info(message, {
		position: "bottom-right",
		autoClose: autoClose * 1000,
		theme: "colored",
	});
}
